import React, { useEffect, useState } from 'react';
import './schedule.css';
import Shc from '../components/common/shc';
import { supabase } from '../supabase';
import Nav from '../components/layout/nav';

const Schedule = () => {
  const [scheduleData, setScheduleData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const fetchSchedule = async () => {
      const { data, error } = await supabase
        .from('schedule')
        .select('*')
        .order('date', { ascending: true })
        .order('time', { ascending: true });

      if (!error) setScheduleData(data);
      else console.error(error);

      setLoading(false);
    };

    fetchSchedule();

    const t = setTimeout(() => {
      setVisible(true);
    }, 50);

    return () => clearTimeout(t);
  }, []);

  return (
    <div className="hcontainer">
      <div className="shomee">

       <div className='homeeeoverlay'>
         <div className="fixedtop">

          <section className={`schedheader ${visible ? 'is-visible' : ''}`}>
            <div className="schedtitle">
              <div className="schedbadge">LIVE EVENT</div>

              <h1>Runway Schedule</h1>

              <p>Cairo Fashion District — May 15–20, 2026</p>
            </div>
          </section>

          <div className="schedticker">
            <div className="tickertrack">
              {[
                'FASHION WEEK',
                'CAIRO 2026',
                'MAY 15–20',
                'RUNWAY SHOWS',
                'EXCLUSIVE ACCESS',
                'FASHION WEEK',
                'CAIRO 2026',
                'MAY 15–20',
                'RUNWAY SHOWS',
                'EXCLUSIVE ACCESS'
              ].map((t, i) => (
                <span key={i}>
                  {t} <span className="tickerdot">✦</span>
                </span>
              ))}
            </div>
          </div>

        </div>

        <section className="schedsection">
          <div className="schedlist">

            {loading ? (
              <div className="loadingwrap">
                <div className="loadingbar">
                  <div className="loadingfill"></div>
                </div>

                <p className="loading">
                  Loading schedule...
                </p>
              </div>
            ) : (
              <Shc data={scheduleData} />
            )}

          </div>
        </section>

        <section className="schednotice">
          <div className="noticeglow"></div>

          <h2>IMPORTANT NOTICE</h2>

          <p>
            Schedule subject to change. Ticket holders will receive updates via email.
            Doors open 30 minutes prior.
          </p>
        </section>
       </div>

      </div>

      <Nav />
    </div>
  );
};

export default Schedule;